import { handleActions } from 'redux-actions'
import { statusCodeToText, handleStateChange } from '../utils'
import {
  SET_MALL_ORDER_LIST_STATE,
  SET_MALL_ORDER_LIST_DATA,
  SET_MALL_ORDER_LIST_REFRESH,
  SET_MALL_ORDER_LIST_INDEX
} from '../constants/mallConstant'

const initState = {
  index: 'all',
  refresh: false,
  data: {
    'all': [],
    'payment': [],
    'delivery': [],
    'sign': [],
    'complete': []
  }
}

let handleItem = (item) => {
  let amount = 0
  let productList = item['wpDeliveryOrderList'].map(i => {
    amount += i['number']
    return {
      id: i['productId'],
      name: i['productName'],
      price: i['productPrice'],
      imgSrc: i['productPic'],
      detailsSrc: i['productDetailPic'],
      amount: i['number']
    }
  })
  let arrItem = {
    orderId: item['orderNum'],
    total: item['actualAmount'],
    amount,
    productList,
    // "status":" 1：待付款,2：待发货,3：待收货,4：已完成“
    status: item['status'],
    statusText: statusCodeToText(item['status']),
    addressData: {}
  }
  if (item['wpDeliveryOrderList'][0]) {
    let i = item['wpDeliveryOrderList'][0]
    Object.assign(arrItem, {
      logisticsCompany: i['logisticsCompany'],
      trackingNumber: i['trackingNumber'],
      createdTime: i['createdTime']
    })
    Object.assign(arrItem.addressData, {
      name: i['receivingName'],
      phone: i['receivingMobile'],
      region: i['region'],
      address: i['receivingAddress']
    })
  }
  if (item['address']) {
    let { address } = item
    Object.assign(arrItem.addressData, {
      name: address['receivingName'],
      phone: address['receivingMobile'],
      region: address['region'],
      address: address['receivingAddress']
    })
  }

  return arrItem
}

// let statusMap = { 1: '待付款', 2: '待发货', 3: '待收货', 4: '已完成', 5: '已取消'}
let statusMap = { 1: 'payment', 2: 'delivery', 3: 'sign', 4: 'complete', 5: 'cancel' }

export const mallOrderList = handleActions({
  [SET_MALL_ORDER_LIST_STATE]: handleStateChange,
  [SET_MALL_ORDER_LIST_REFRESH]: state => {
    return { ...state, refresh: true }
  },
  [SET_MALL_ORDER_LIST_INDEX]: (state, action) => {
    return { ...state, index: action.payload }
  },
  [SET_MALL_ORDER_LIST_DATA]: (state, action) => {
    let data = {
      all: [],
      payment: [],
      delivery: [],
      sign: [],
      complete: []
    }
    data.all = action.payload.map(item => {
      let status = statusMap[item['status']]
      let i = handleItem(item)
      // 预防出现例如status为其他的坑爹状况
      if (data[status]) data[status].push(i)
      return i
    })

    return {
      refresh: false,
      loading: false,
      errorMessage: '',
      data: data,
      index: state['index']
    }
  }
}, initState)
